<ng-container *transloco="let t; read: 'terms'">
  <ng-container *transloco="let gt; read: 'general'">
    <div data-test-id="terms-dialog-content"  mat-dialog-content cdkScrollable #scrollable class="px-0 px-sm-4">
      <app-managed-terms-of-use data-test-id="terms-managed-terms-of-use"  style="height: max-content"></app-managed-terms-of-use>
    </div>
    <div data-test-id="terms-dialog-actions"  mat-dialog-actions class="flex-row-reverse">
      <button data-test-id="terms-dialog-close"  class="btn btn-primary" cdkFocusInitial mat-dialog-close>{{ gt("closeButton") }}</button>
    </div>
  </ng-container>
</ng-container>
